/**
 * FilterCheckbox - Reusable checkbox item for filter sidebars
 * Used in category, subcategory, and search page sidebars
 */
const FilterCheckbox = ({ 
  label, 
  checked, 
  onChange, 
  testId 
}) => {
  return (
    <label
      className="flex items-center gap-2 py-1.5 px-2 cursor-pointer hover:bg-site-bg-alt transition-colors group"
      data-testid={testId}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className="checkbox-custom"
      />
      <span className={`font-mono text-[11px] uppercase tracking-wide text-black ${checked ? 'font-medium' : ''}`}>
        {label}
      </span>
    </label>
  );
};

export default FilterCheckbox;
